"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    editPropertyDesignFloodElevation: {
        path: "/properties/:propertyId/design-flood-elevation"
    },
    createProperty: {
        path: "/properties/create"
    },
    editProperty: {
        path: "/properties/:propertyId/edit"
    },
    properties: {
        path: "/properties"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvcHJvcGVydGllcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIGVkaXRQcm9wZXJ0eURlc2lnbkZsb29kRWxldmF0aW9uOiB7XG4gICAgcGF0aDogXCIvcHJvcGVydGllcy86cHJvcGVydHlJZC9kZXNpZ24tZmxvb2QtZWxldmF0aW9uXCIsXG4gIH0sXG4gIGNyZWF0ZVByb3BlcnR5OiB7XG4gICAgcGF0aDogXCIvcHJvcGVydGllcy9jcmVhdGVcIixcbiAgfSxcbiAgZWRpdFByb3BlcnR5OiB7XG4gICAgcGF0aDogXCIvcHJvcGVydGllcy86cHJvcGVydHlJZC9lZGl0XCIsXG4gIH0sXG4gIHByb3BlcnRpZXM6IHtcbiAgICBwYXRoOiBcIi9wcm9wZXJ0aWVzXCIsXG4gIH0sXG59KTtcbiJdLCJuYW1lcyI6WyJyb3V0ZXMiLCJidWlsZFJvdXRlcyIsImVkaXRQcm9wZXJ0eURlc2lnbkZsb29kRWxldmF0aW9uIiwicGF0aCIsImNyZWF0ZVByb3BlcnR5IiwiZWRpdFByb3BlcnR5IiwicHJvcGVydGllcyJdLCJtYXBwaW5ncyI6Ijs7OzsrQkFFYUE7OztlQUFBQTs7O3VCQUZlO0FBRXJCLE1BQU1BLFNBQVNDLElBQUFBLGtCQUFXLEVBQUM7SUFDaENDLGtDQUFrQztRQUNoQ0MsTUFBTTtJQUNSO0lBQ0FDLGdCQUFnQjtRQUNkRCxNQUFNO0lBQ1I7SUFDQUUsY0FBYztRQUNaRixNQUFNO0lBQ1I7SUFDQUcsWUFBWTtRQUNWSCxNQUFNO0lBQ1I7QUFDRiJ9